import { useEffect } from 'react';

const ArticleSchema = ({ article }) => {
  useEffect(() => {
    if (!article) return;

    const schema = {
      "@context": "https://schema.org",
      "@type": "BlogPosting",
      "headline": article.title,
      "description": article.excerpt,
      "image": article.featuredImage,
      "datePublished": article.datePublished || new Date().toISOString(),
      "dateModified": article.dateModified || new Date().toISOString(),
      "author": {
        "@type": "Person",
        "name": article.author,
        "url": "https://smartlifechoice.co.uk"
      },
      "publisher": {
        "@type": "Organization",
        "name": "SmartLifeChoice",
        "logo": {
          "@type": "ImageObject",
          "url": "https://smartlifechoice.co.uk/logo-og.png"
        }
      },
      "mainEntityOfPage": {
        "@type": "WebPage",
        "@id": `https://smartlifechoice.co.uk/article/${article.id}`
      },
      "articleSection": article.category,
      "keywords": article.tags ? article.tags.join(', ') : '',
      "wordCount": article.content ? article.content.split(' ').length : 0,
      "articleBody": article.content ? article.content.replace(/<[^>]*>/g, '').substring(0, 500) : ''
    };

    const scriptElement = document.createElement('script');
    scriptElement.type = 'application/ld+json';
    scriptElement.id = 'article-schema';
    scriptElement.textContent = JSON.stringify(schema);
    document.head.appendChild(scriptElement);

    return () => {
      const existingScript = document.getElementById('article-schema');
      if (existingScript && existingScript.parentNode) {
        existingScript.parentNode.removeChild(existingScript);
      }
    };
  }, [article]);

  return null;
};

export default ArticleSchema;
